import * as axs from "axios";

const axios = {
    get: async (url, params) => {
        const endPointUrl = getEndPointUrl(url);
        const headers = getHeaders();

        return axs.get(endPointUrl, { params, ...headers });
    },
    post: async (url, body) => {
        const endPointUrl = getEndPointUrl(url);
        const headers = getHeaders();

        return axs.post(endPointUrl, body, { ...headers });
    },
};

const getHeaders = () => {
    let headers = { "Content-Type": "application/json" };

    const token = localStorage.getItem("@storage_token");

    if (token) {
        headers = Object.assign({}, headers, {
            Authorization: "Bearer " + token,
        });
    }

    return { headers };
};

const getEndPointUrl = (path) => {
    const endpoint = process.env.REACT_APP_API_URL + path;
    return endpoint;
};

export default axios;
